module.exports = __webpack_public_path__ + "img/order_session_icon_gray.ba8e0edd.svg";